<template>
  <div v-if="$i18n.locale === 'th'" class="card border-inside">
    <div v-if="getRule == 'startup'" class="card-content th info-list">
      <p>
        <span class="has-text-weight-normal">Investment Support: </span>
        แสดงข้อมูลเงินทุนของ Company (ผู้ประกอบการ) ที่ได้ทำการขออนุมัติเงิน
        และเงินที่ได้รับการอนุมัติ โดยจะแสดงจาก Category (หมวดหมู่) ของ Batch
        (โครงการ) <br /><span class="has-text-weight-normal">ส่วนที่ 1</span>
        <span class="text-batch">ตัวหนังสือสีเขียว</span>
        แสดงจำนวนเงินที่ได้รับการอนุมัติทั้งหมด เป็นตัวเลข และหน่วยบาท
        <br />โดยมีจำนวนเงินแบบย่อ คือ K = หลัก 1,000 / M = หลัก 1,000,000 / B =
        หลัก 1,000,000,000 <br /><span class="has-text-weight-normal"
          >ส่วนที่ 2</span
        >
        ตัวเลข แสดง Category (หมวดหมู่)
      </p>
      <ul>
        <li>
          ด้านล่างซ้ายแสดงเงินที่ Approved (อนุมัติ) แสดงเป็นตัวเลข และหน่วยบาท
        </li>
        <li>
          ด้านล่างขวาแสดงเงินที่ Pending (ตั้งเบิก) แสดงเป็นตัวเลข และหน่วยบาท
        </li>
      </ul>
      <p>
        <span class="has-text-weight-normal">ส่วนที่ 3</span>
        แถบแสดงจำนวนเงินที่สัมพันธ์กับจำนวนเงินทั้งซ้ายและขวา
      </p>
      <ul>
        <li>เส้นสีม่วงคือ เงินที่ทำการ Approved (อนุมัติ)</li>
        <li>เส้นสีเทา คือเงินที่ Pending (ตั้งเบิก)</li>
      </ul>
      <p>
        ถ้าหากได้รับการอนุมัติเงินที่ขอทั้งหมดแล้วเส้นสีม่วงจะเต็มช่อง เงินที่
        Pending (ตั้งเบิก) จะเป็น 0 บาท และถ้าหากทำการ Pending (ตั้งเบิก) มาใหม่
        เส้นสีม่วงจะแสดงเป็นเปอร์เซ็นต์ให้สัมพันธ์กับจำนวนเงินทั้ง เงินที่
        Approved (อนุมัติ) และเงินที่ Pending (ตั้งเบิก)
      </p>
      <hr />
      <p>** หมายเหตุ</p>
      <ol>
        <li>
          Pending (ตั้งเบิก) เงินทุนที่ได้ทำการขอแต่ยังไม่ได้รับการอนุมัติ ใน
          Task (กิจกรรมย่อย) Fund status (สถานะการเบิกเงิน) เป็น Pending
          (ตั้งเบิก)
        </li>
        <li>
          Approved (อนุมัติ) เงินทุนที่ได้รับการอนุมัติใน Task (กิจกรรมย่อย)
          Fund status (สถานะการเบิกเงิน) จะเป็น Approved (อนุมัติ)
        </li>
      </ol>
    </div>
    <div v-else class="card-content th info-list">
      <p>
        <span class="has-text-weight-normal">Investment Support: </span>
        แสดงข้อมูลเงินทุนของ Company (ผู้ประกอบการ) ทั้งหมดใน Batch (โครงการ)
        ที่ได้ทำการขออนุมัติเงิน และเงินที่ได้รับการอนุมัติ โดยจะแสดงจาก
        Category (หมวดหมู่) ของ Batch (โครงการ) แสดงข้อมูลดังนี้
      </p>
      <br /><span class="has-text-weight-normal">ส่วนที่ 1</span> แสดงข้อมูล
      Approved (อนุมัติ) และ Pending (ตั้งเบิก) ดังนี้
      <ul>
        <li>
          <span class="has-text-weight-normal done-color"
            >Approved: ฿ 100K / ฿ 150K</span
          >
          ตัวเลขสีเขียว ด้านหน้าแสดงจำนวนเงินที่อนุมัติแล้วของ Company
          (ผู้ประกอบการ) ที่สามารถเห็นได้ในโครงการเป็นตัวเลข และหน่วยบาท
          ตัวเลขสีเขียว ด้านหลังแสดงจำนวนเงินที่อนุมัติแล้วทั้งหมดของ Company
          (ผู้ประกอบการ) และ จำนวนเงินที่ Staff (เจ้าหน้าที่)
          ได้อนุมัติโดยที่ไม่แสดงให้ Company (ผู้ประกอบการ)
          เห็นในโครงการเป็นตัวเลข และหน่วยบาท
        </li>
        <li>
          <span class="has-text-weight-normal text-grey-light"
            >Pending: ฿ 50K / ฿ 80K</span
          >
          ตัวเลขสีเทา ด้านหน้าแสดงจำนวนเงินที่ Pending (ตั้งเบิก) ของ Company
          (ผู้ประกอบการ) ที่สามารถเห็น ในโครงการเป็นตัวเลข และหน่วยบาท
          ตัวเลขสีเทา ด้านหลังแสดงจำนวนเงินที่ Pending (ตั้งเบิก) ทั้งหมดของ
          Company (ผู้ประกอบการ) และ จำนวนเงินที่ Staff (เจ้าหน้าที่)
          ได้ทำการตั้งเบิกโดยที่ไม่แสดงให้ Company (ผู้ประกอบการ)
          เห็นในโครงการเป็นตัวเลข และหน่วยบาท
        </li>
        <br />แสดงจำนวนเงินแบบย่อ คือ K = หลัก 1,000 / M = หลัก 1,000,000 / B =
        หลัก 1,000,000,000
      </ul>
      <span class="has-text-weight-normal">ส่วนที่ 2</span> แสดง Category
      (หมวดหมู่)
      <ul>
        <li>ด้านล่างซ้ายแสดงเงินที่ Approved (อนุมัติ)</li>
        <li>
          ด้านหน้าแสดงจำนวนเงินที่ Company (ผู้ประกอบการ) สามารถเห็นในโครงการ
          โดยแสดงเป็นตัวเลข และหน่วยบาท
        </li>
        <li>
          ด้านหลังแสดงจำนวนเงินที่อนุมัติแล้วทั้งหมดของ Company (ผู้ประกอบการ)
          และ จำนวนเงินที่ Staff (เจ้าหน้าที่) ได้อนุมัติโดยที่ไม่แสดงให้
          Company (ผู้ประกอบการ) เห็น โดยแสดงเป็นตัวเลข และหน่วยบาท
        </li>
        <li>ด้านล่างขวาแสดงเงินที่ Pending (ตั้งเบิก)</li>
        <li>
          ด้านหน้าแสดงจำนวนเงินที่ Pending (ตั้งเบิก) ของ Company (ผู้ประกอบการ)
          ที่สามารถเห็นในโครงการ โดยแสดงเป็นตัวเลข และหน่วยบาท
        </li>
        <li>
          ด้านหลังแสดงจำนวนเงินที่ Pending (ตั้งเบิก) ทั้งหมดของ Company
          (ผู้ประกอบการ) และ จำนวนเงินที่ Staff (เจ้าหน้าที่)
          ได้ทำการตั้งเบิกโดยที่ไม่แสดงให้ Company (ผู้ประกอบการ) เห็นในโครงการ
          โดยแสดงเป็นตัวเลข และหน่วยบาท
        </li>
      </ul>
      <span class="has-text-weight-normal">ส่วนที่ 3</span>
      แถบแสดงจำนวนเงินที่สัมพันธ์กับจำนวนเงินทั้งซ้ายและขวา
      <ul>
        <li>เส้นเขียวงคือ เงินที่ทำการ Approved (อนุมัติ)</li>
        <li>เส้นสีเทา คือเงินที่ Pending (ตั้งเบิก)</li>
      </ul>
      <br />
      ถ้าหากได้รับการอนุมัติเงินที่ขอทั้งหมดแล้วเส้นสีเขียวจะเต็มช่อง เงินที่
      Pending (ตั้งเบิก) จะเป็น 0 บาท และถ้าหากทำการ Pending (ตั้งเบิก) มาใหม่
      เส้นสีม่วงจะแสดงเป็นเปอร์เซ็นต์ให้สัมพันธ์กับจำนวนเงินทั้ง เงินที่
      Approved (อนุมัติ) และเงินที่ Pending (ตั้งเบิก)
      <hr />
      ** หมายเหตุ
      <ul>
        <li>
          Pending (ตั้งเบิก) เงินทุนที่ได้ทำการขอแต่ยังไม่ได้รับการอนุมัติ ใน
          Task (กิจกรรมย่อย) Fund status (สถานะการเบิกเงิน) เป็น Pending
          (ตั้งเบิก)
        </li>
        <li>
          Approved (อนุมัติ) เงินทุนที่ได้รับการอนุมัติใน Task (กิจกรรมย่อย)
          Fund status (สถานะการเบิกเงิน) จะเป็น Approved (อนุมัติ)
        </li>
      </ul>
    </div>
  </div>
  <div v-else class="card border-inside">
    <div v-if="getRule == 'startup'" class="card-content th info-list">
      <p>
        <span class="has-text-weight-normal">Investment Support: </span>
        Shows the funding information of the Company that have requested money
        approval. and approved funds, which are displayed by Category of the
        Batch. <br /><span class="has-text-weight-normal">ส่วนที่ 1</span>
        <span class="text-batch">Green text</span>
        Displays all approved amounts in numbers and in baht.
        <br />The abbreviated amount is K = Principal 1,000 / M = Principal
        1,000,000 / B = Main 1,000,000,000 <br /><span
          class="has-text-weight-normal"
          >Part 2</span
        >
        Numbers show Category
      </p>
      <ul>
        <li>
          The bottom left shows the money that has been approved displayed in
          numbers and in baht.
        </li>
        <li>
          The bottom right shows the money pending displayed in numbers and in
          baht.
        </li>
      </ul>
      <p>
        <span class="has-text-weight-normal">Part 3</span>
        The bar shows the amount relative to the amount on the left and right.
      </p>
      <ul>
        <li>The purple line is the money that has been approved.</li>
        <li>The gray line is the pending money.</li>
      </ul>
      <p>
        If all the requested funds are approved, the purple line will fill the
        available funds. Pending will be 0 baht and if pending again The purple
        line is shown as a percentage relative to the total amount. Approved and
        Pending money
      </p>
      <hr />
      <p>** Note</p>
      <ol>
        <li>
          Pending Funds that have been requested but have not been approved in
          Task (sub-activity) Fund status to Pending
        </li>
        <li>
          Approved Funds approved in a Task, Fund status will be Approved.
        </li>
      </ol>
    </div>
    <div v-else class="card-content th info-list">
      <p>
        <span class="has-text-weight-normal">Investment Support: </span>
        Displays the capital information of all companies in the batch project
        that have requested and received approval for funding. It will be shown
        based on the category of the batch project, as follows
      </p>
      <br /><span class="has-text-weight-normal">Part 1</span> Displays the
      Approved and Pending data as follows
      <ul>
        <li>
          <span class="has-text-weight-normal done-color"
            >Approved: ฿100K / ฿150K</span
          >
          (green numbers) The number displayed in front represents the approved
          amount in Thai Baht (THB) for the company visible in the project. The
          number displayed in green at the back represents the total approved
          amount for the company and the amount approved by staff, which is not
          visible to the company in the project, both in THB.
        </li>
        <li>
          <span class="has-text-weight-normal text-grey-light"
            >Pending: ฿50K / ฿80K</span
          >
          (gray numbers): The number displayed in front represents the pending
          amount in THB for the company visible in the project. The number
          displayed in gray at the back represents the total pending amount for
          the company and the amount requested by staff, which is not visible to
          the company in the project, both in THB.
        </li>
        <br />The abbreviated currency format is as follows: K = 1,000
        (thousands) / M = 1,000,000 (millions) / B = 1,000,000,000 (billions)
      </ul>
      <span class="has-text-weight-normal">Part 2</span> Displays the Categories
      as follows
      <ul>
        <li>Bottom left: Shows the Approved amount.</li>
        <li>
          Front: Displays the amount of money that the company can see in the
          project, represented as a numerical value and in Thai Baht.
        </li>
        <li>
          Back: Shows the total approved amount for the company and the amount
          approved by staff, without being visible to the company in the
          project, both in Thai Baht.
        </li>
        <li>Bottom right: Shows the Pending amount.</li>
        <li>
          Front: Displays the amount of money pending for the company in the
          project, represented as a numerical value and in Thai Baht.
        </li>
        <li>
          Back: Shows the total pending amount for the company and the amount
          requested by staff, without being visible to the company in the
          project, both in Thai Baht.
        </li>
      </ul>
      <span class="has-text-weight-normal">Part 3</span> Displays the
      relationship between the amounts on the left and right sides
      <ul>
        <li>Green line: Represents the amount that has been approved.</li>
        <li>Gray line: Represents the amount that is pending.</li>
      </ul>
      <br />
      If all requested amounts have been approved, the green line will fill the
      bar completely, and the pending amount will be 0 Baht. If there is a new
      pending amount, a purple line will appear, indicating the percentage in
      relation to the approved amount and the pending amount.
      <hr />
      ** Note
      <ul>
        <li>
          Pending: Refers to the requested fund that has been submitted but has
          not yet been approved. In the "Fund Status" of the subtask, it will be
          indicated as "Pending."
        </li>
        <li>
          Approved: Refers to the fund that has been approved in the subtask. In
          the "Fund Status" of the subtask, it will be indicated as "Approved."
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
  },
};
</script>